<template>
    <div>
        <div class="top-banner">
            <div class="top-banner-title">聚合收银台</div>
            <div class="top-banner-detail">专业的APP内SDK收银台</div>
            <div class="top-banner-try" @click="queryToTry">马上试用</div>
            <div class="top-banner-buy" @click="queryToBuy">购买咨询</div>
        </div>
        <m-qr-code id="QRCode" :conditions="qrcodeConditions" @hideQrCode="hideQrCode" style="display: none;"></m-qr-code>
        <div class="desc-content">
            <div class="cashier-unity-desc">聚合<span>微信SDK、支付宝SDK、银联SDK、蜜堂人脸支付SDK</span>为一体一点接入快速商用</div>
            <img class="overview-img" src="@/assets/img/product/cashier_overview.png"/>
            <div>
                <div class="cashier-unity-desc-item">产品优势</div>
                <div class="bottom_hint"></div>
                <ul class="cashier-advantage-flex-ul">
                    <li class="cashier-desc-advantage-item">
                        <img src="@/assets/img/product/cashier_advantage_1.png"/>
                        <div class="cashier-desc-advantage-item-detail-title">
                            <label>一站式</label>
                            <div>客户直签支付机构<br>一站管理</div>
                        </div>
                    </li>
                    <li class="cashier-desc-advantage-item">
                        <img src="@/assets/img/product/cashier_advantage_2.png"/>
                        <div class="cashier-desc-advantage-item-detail-title">
                            <label>稳定</label>
                            <div>每日百万级交易验证<br>每日百万用户使用，覆盖各类手机</div>
                        </div>
                    </li>
                    <li class="cashier-desc-advantage-item">
                        <img src="@/assets/img/product/cashier_advantage_3.png"/>
                        <div class="cashier-desc-advantage-item-detail-title">
                            <label>免费</label>
                            <div>工具包完全免费</div>
                        </div>
                    </li>
                </ul>
                <div class="cashier-unity-desc-item">助力场景</div>
                <div class="bottom_hint"></div>
                <div class="cashier-unity-desc-scene margin-25">
                    <img class="cashier-scene-img-left" src="@/assets/img/product/cashier_scene_1.png"/>
                    <img class="cashier-scene-img-right" src="@/assets/img/product/cashier_scene_2.png"/>
                    <label class="cashier-unity-desc-scene-left">电商</label>
                    <label class="cashier-unity-desc-scene-right">娱乐</label>
                </div>
            </div>
            <div class="cashier-unity-contact-us">
                <div class="cashier-unity-contact-us-prompt">这个智能时代，我们将成为您最可靠的伙伴</div>
                <div class="cashier-contact-us" @click="queryToBuy">联系我们</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../components/Global.vue';
    import MQrCode from '../../components/MQrcode.vue';
    export default {
        name: "Product",
        components: {
            MQrCode
        },
        methods :{
            queryToTry: function () {
                //试用
                document.getElementById('QRCode').style.display = 'block';
            },
            queryToBuy: function () {
                //购买
                this.$router.push(Global.routes.aboutCooperation);
            },
            hideQrCode: function () {
                document.getElementById('QRCode').style.display = 'none';
            }
        },
        data() {
            return {
                qrcodeConditions: {
//                    width: '200px',
                    url: 'https://static.91mika.com/app-static/app.html'
                }
            }
        }
    }
</script>

<style scoped>

    @import "../../assets/css/base.css";

    .margin-25 {
        margin-top: 25px;
    }

    .bottom_hint {
        width: 100px;
        height: 4px;
        margin: 16px auto auto;
        background: #4183D7;
    }

    .top-banner {
        position: relative;
        width: 100%;
        height: 360px;
        background: url("../../assets/img/product/cashier_back_banner.png") no-repeat;
        background-size:cover;
    }

    .top-banner-title {
        position: absolute;
        left: 130px;
        top: 85px;
        font-size: 60px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }

    .top-banner-detail {
        position: absolute;
        left: 130px;
        top: 200px;
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
    }

    .top-banner-try {
        position: absolute;
        left: 130px;
        bottom: 39px;
        width: 160px;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        background: #4183D7;
        color: white;
        border-radius: 2px;
        text-align: center;
    }

    .top-banner-buy {
        position: absolute;
        left: 300px;
        bottom: 39px;
        width: 160px;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        background: white;
        color: #4183D7;
        border-radius: 2px;
        text-align: center;
    }
    .desc-content {
        text-align: center;
    }

    .cashier-unity-desc {
        padding-left: 80px;
        padding-right: 80px;
        margin-top: 70px;
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Light, PingFang SC;
        color: #3A404D;
    }
    .cashier-unity-desc span {
        color: #3C3C3C;
        font-weight: bold;
    }
    .overview-img {
        margin-top: 70px;
        height: 120px;
    }
    .cashier-unity-desc-item {
        margin-top: 70px;
        margin-left: 80px;
        margin-right: 80px;
        padding-top: 70px;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        color: #000000;
        height: 56px;
        line-height: 56px;
        border-top: dotted #1968FC 1px;
    }

    .cashier-advantage-flex-ul {
        display: flex;
        justify-content: center;
    }

    .cashier-desc-advantage-item {
        margin-top: 60px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 30%;
    }

    .cashier-desc-advantage-item img {
        margin: auto;
        width: 300px;
        height: 225px;
    }


    .cashier-desc-advantage-item-detail-title {
        text-align: center;
    }

    .cashier-desc-advantage-item-detail-title div {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404D;
        line-height: 28px;
    }

    .cashier-desc-advantage-item-detail-title label {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
    }


    .cashier-unity-desc-scene {
        padding: 15px 80px;
        position: relative;
    }

    .cashier-scene-img-left {
        width: 47%;
        max-width: 600px;
        min-width: 100px;
        margin-left: 3%;
    }

    .cashier-scene-img-right {
        width: 47%;
        max-width: 600px;
        min-width: 100px;
        margin-right: 3%;
    }


    .cashier-unity-desc-scene-left {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        position:absolute;
        width: 43%;
        top: 15px;
        bottom: 0;
        left: 0;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
        padding-right: 7%;
    }

    .cashier-unity-desc-scene-right {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        position:absolute;
        width: 43%;
        top: 15px;
        bottom: 0;
        left: 50%;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
        padding-left: 7%;
    }

    .cashier-unity-contact-us {
        margin-top: 70px;
        position: relative;
        width: 100%;
        height: 200px;
        background: url("../../assets/img/product/contact_us_back.png") no-repeat;
        background-size:cover;
        text-align: center;
    }

    .cashier-unity-contact-us-prompt {
        padding-top: 40px;
        font-size: 40px;
        font-family: PingFangSCRegular;
        color: #FFFFFF;
    }
    .cashier-contact-us {
        position: absolute;
        bottom: 40px;
        left: 0;
        right: 0;
        margin: 0 auto;
        background: #4183D7;
        border-radius: 8px;
        color: white;
        font-size: 25px;
        font-family: PingFangSC-Regular, PingFang SC;
        width: 150px;
        height: 55px;
        line-height: 55px;
    }

</style>